/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_ProvisionInputs */

const cs_col_provision = /** @type {(inputs: Col_ProvisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provize`)
};

const en_col_provision = /** @type {(inputs: Col_ProvisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commission`)
};

/**
* | output |
* | --- |
* | "Commission" |
*
* @param {Col_ProvisionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_provision = /** @type {((inputs?: Col_ProvisionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_ProvisionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_provision(inputs)
	return cs_col_provision(inputs)
});